var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.69 49.21a1.5 1.5 0 0 1-.61-.13 1.54 1.54 0 0 1-.89-1.77l5.59-19.85a.5.5 0 0 0-.48-.64h-8.91a1 1 0 0 1-.91-1.41l11-24a1 1 0 0 1 .91-.59h12.2a1 1 0 0 1 .92 1.41l-5 11.19a.49.49 0 0 0 .45.7h7.62a1 1 0 0 1 .84 1.55L18 48.51a1.52 1.52 0 0 1-1.31.7m-2.5-24.69h8.48a1 1 0 0 1 1 1.27l-4.86 17.3L35.7 17.16a.5.5 0 0 0-.41-.77h-7.06a1 1 0 0 1-.92-1.39l5.28-11.91h-9.36l-9.49 20.72a.5.5 0 0 0 .45.71"
  })));
};
export default SvgFlash;